import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

import { ref, onMounted, inject } from "vue";
import { useStore } from "@/store";
import { InfoFilled } from "@element-plus/icons-vue";
import ToolServices from "../services/ToolServices";
import { ElNotification } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViolationList',
  setup(__props) {

const isLoading = inject<any>("isLoading");
const detail = ref(Array<any>());

const store = useStore();
const siteId = ref(store.state.AuthModule.config.siteId);

const fetchData = async () => {
  isLoading.value = true;
  try {
    const data = await ToolServices.getViolationList(siteId.value);
    detail.value = data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const deleteViolationUser = async (ip: string) => {
  try {
    await ToolServices.deleteViolationUser(siteId.value, ip);
    fetchData();
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.violationList")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("title.accountNumber")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("title.reasons")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.staff")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
          ])
        ]),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!_unref(isLoading) && detail.value?.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.accountNumber), 1),
                    _createElementVNode("td", null, [
                      (item.user)
                        ? (_openBlock(), _createBlock(_component_UserInfo, {
                            key: 0,
                            user: item.user,
                            isAdmin: 
                  item.user.isAdmin == undefined ? false : item.user.isAdmin
                ,
                            class: "me-2"
                          }, null, 8, ["user", "isAdmin"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.value), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_popconfirm, {
                        "confirm-button-text": "Yes",
                        "cancel-button-text": "No",
                        icon: _unref(InfoFilled),
                        "icon-color": "#626AEF",
                        title: "Are you sure to remove this user from blocked list?",
                        onConfirm: ($event: any) => (deleteViolationUser(item.ip))
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_button, { type: "danger" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.remove")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["icon", "onConfirm"])
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ])
  ]))
}
}

})